import cdnImages from 'src/constants/cdnImages';
import styles from './thumbnailDisplay.styles.scss';
import { IMAGE_ALLOWED_FILES, RAW_ALLOWED_FILES } from 'src/components/Cloudinary/cloudinary.constants';

/**
 * Determines the image source, alt text, and class for a thumbnail image based on the file type.
 *
 * @param {Object} options - The options object containing `url`, `fileType`, and `altText` properties.
 * @returns {Object} - The image configuration object with `imgSrc`, `altText`, and `imgClass` properties.
 */
export const getImageElementConfig = ({url = '', fileType = '', altText = '', transformedFile = ''}) => {
  const fileTypeLower = fileType.toLowerCase();
  let imgSrc = '';
  let imgClass = '';

  switch (true) {
    case IMAGE_ALLOWED_FILES.includes(fileTypeLower):
      imgSrc = url;
      imgClass = styles.thumbnailImage;
      break;
    case RAW_ALLOWED_FILES.includes(fileTypeLower):
      imgSrc = cdnImages.spreadsheetIcon;
      imgClass = styles.thumbnailIcon;
      break;
    default:
      imgSrc = cdnImages.fileIcon;
      imgClass = styles.thumbnailIcon;
  }

  return {
    imgSrc,
    altText,
    imgClass,
    transformedFile,
  };
};
